import 'sweetalert2/dist/sweetalert2.min.css';
import VueMask from "v-mask";
import Vue from "vue";
import VueSweetalert2 from 'vue-sweetalert2';
import App from "./App.vue";
import "./assets/styles/_main.scss";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

import "vuetify/dist/vuetify.min.css";

Vue.use(VueMask);
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

Vue.config.warnHandler = (msg, vm, trace) => {
  if (msg.includes('Duplicate keys detected')) {
    return;
  }
  
  // Para manter os outros warnings no console
  console.warn(`[Vue warn]: ${msg}`, vm, trace);
};

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");